/* Frozen bd24583 WelcomePopup; native Shopify customer POST owns the outcome. */
(function () {
  'use strict';
  const DAY = 86400000, STORAGE = 'dirt.welcome.newsletter.v1', SESSION = 'dirt.welcome.shown.v1';
  const eligible = page => ['home', 'wine-collection', 'package-collection'].includes(page);
  const safe = (fn, fallback) => {try {return fn();} catch (_) {return fallback;}};
  function createWelcome(env) {
    const preference = safe(env.readLocal, null) || {};
    let autoAfter = Number(preference.autoAfter) || 0, hiddenUntil = Number(preference.hiddenUntil) || 0;
    let shown = !!safe(env.readSession, false), disposed = false;
    const state = {open: false, teaser: false, activeSeconds: 0};
    const emit = () => env.changed({...state});
    const remember = () => safe(() => env.writeLocal({autoAfter, hiddenUntil}));
    function show() {
      if (disposed || !env.eligible || state.open) return;
      shown = true; safe(() => env.writeSession(true));
      state.open = true; state.teaser = true; emit();
      if (env.open() === false) {state.open = false; emit();}
    }
    function close(rememberDismiss = true) {
      state.open = false;
      if (rememberDismiss) {autoAfter = env.now() + 7 * DAY; remember();}
      state.teaser = hiddenUntil <= env.now(); emit();
    }
    const api = {
      show, close,
      state: () => ({...state}),
      hide() {autoAfter = env.now() + 30 * DAY; hiddenUntil = autoAfter; remember(); state.teaser = false; emit(); env.restoreFocus();},
      accepted() {autoAfter = env.now() + 7 * DAY; hiddenUntil = 0; remember();},
      tick({visible, blocked = false, typing = false}) {
        if (disposed || !env.eligible || env.preview || hiddenUntil > env.now() || autoAfter > env.now() || shown) return;
        if (!visible || blocked || typing) {state.activeSeconds = 0; return;}
        if (++state.activeSeconds >= 12) show();
      },
      dispose() {disposed = true;},
    };
    state.teaser = env.eligible && hiddenUntil <= env.now() && (autoAfter > env.now() || shown); emit();
    if (env.preview) show();
    return api;
  }
  function createSubmission(env) {
    let pending = false, attempt = 0, timer;
    function reset() {attempt++; pending = false; env.cancel(timer); env.busy(false);}
    return {
      reset,
      submit(event, field) {
        if (pending) {event.preventDefault(); return;}
        const message = !field.value.trim() ? 'Vul je e-mailadres in.' : !field.validity.valid ? 'Controleer je e-mailadres, bijvoorbeeld naam@voorbeeld.nl.' : '';
        if (message) {event.preventDefault(); env.error(message); field.focus(); return;}
        env.error(''); pending = true;
        const current = ++attempt;
        // Inspect cancellation in the next task, after every target/bubbling captcha listener.
        env.defer(() => {
          if (attempt !== current) return;
          if (event.defaultPrevented) {pending = false; return;}
          env.busy(true); env.accepted?.();
          // Native navigation/captcha remains authoritative. Same-page failures may retry.
          timer = env.later(reset, 8000);
        });
      },
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {eligible, createWelcome, createSubmission};
  if (typeof window === 'undefined') return;
  const paper = window.DirtPaper ||= {};
  if (paper.newsletter) return;
  const roots = new Map(), forms = new WeakMap();
  let leaving = false, shownInThisPage = false;
  function submission(form) {
    if (forms.has(form)) return forms.get(form);
    const field = form.querySelector('[name="contact[email]"]'), button = form.querySelector('button[type="submit"]');
    if (!field || !button) return null;
    const original = button.firstChild?.textContent || '', welcome = form.id === 'welcome-newsletter-form';
    const error = form.querySelector('[data-newsletter-error]'), serverError = form.querySelector('[data-newsletter-server-error]');
    const controller = createSubmission({
      defer: fn => setTimeout(fn, 0), later: setTimeout, cancel: clearTimeout,
      busy(value) {
        form.setAttribute('aria-busy', String(value)); button.disabled = value;
        if (button.firstChild) button.firstChild.textContent = value ? 'Aanmelding versturen…' : original;
      },
      error(message) {
        if (welcome && error) {if (serverError) serverError.hidden = true; error.textContent = message; error.hidden = !message; field.setAttribute('aria-invalid', String(!!message)); if (message) field.setAttribute('aria-describedby', error.id); else field.removeAttribute('aria-describedby');}
        else if (message) field.reportValidity();
      },
      accepted() {if (welcome) for (const state of roots.values()) state.controller.accepted();},
    });
    forms.set(form, controller); return controller;
  }
  function mount(root) {
    if (roots.has(root)) return;
    const abort = new AbortController(), signal = abort.signal, teaser = root.querySelector('.welcome-teaser');
    const trigger = root.querySelector('.welcome-teaser-open'), hide = root.querySelector('.welcome-teaser-hide');
    let previousFocus = document.activeElement, email = null, errorText = '', serverErrorCleared = false, busy = false, dialog;
    const listen = (node, event, fn, options = {}) => node?.addEventListener(event, fn, {...options, signal});
    function blocked() {
      const mixing = document.querySelector('[data-mixing="true"]')?.getBoundingClientRect();
      if (mixing && mixing.top < innerHeight && mixing.bottom > 0) return true;
      return [...document.querySelectorAll('dialog[open], [role="dialog"], [aria-haspopup][aria-expanded="true"], .style-menu-embedded [aria-expanded="true"]')]
        .some(node => !node.closest('[data-welcome-dialog]') && node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden');
    }
    function refresh() {busy = blocked(); const state = controller.state(); const hidden = !state.teaser || state.open || busy; if (teaser.hidden !== hidden) teaser.hidden = hidden;}
    let controller;
    // Preview opening is deferred until the controller and listeners are ready.
    const preview = new URLSearchParams(location.search).get('welkom') === '1';
    controller = createWelcome({
      now: Date.now, eligible: eligible(root.dataset.welcomePage), preview: false,
      readLocal: () => JSON.parse(localStorage.getItem(STORAGE) || '{}'),
      writeLocal: value => localStorage.setItem(STORAGE, JSON.stringify(value)),
      readSession: () => shownInThisPage || sessionStorage.getItem(SESSION) === '1', writeSession: () => {shownInThisPage = true; sessionStorage.setItem(SESSION, '1');},
      changed: state => {const hidden = !state.teaser || state.open || busy; if (teaser.hidden !== hidden) teaser.hidden = hidden;},
      open: () => paper.openDialog?.('welcome', trigger) || false,
      restoreFocus() {if (document.activeElement?.closest('.welcome-teaser')) (previousFocus?.isConnected ? previousFocus : document.querySelector('header a[href]'))?.focus({preventScroll: true});},
    });
    listen(trigger, 'click', () => controller.show()); listen(hide, 'click', () => controller.hide());
    listen(document, 'focusin', event => {if (!event.target.closest('.welcome-teaser, [data-welcome-dialog]')) previousFocus = event.target;});
    listen(document, 'dirt:dialog-open', event => {
      if (event.detail.name !== 'welcome') return;
      dialog = event.detail.dialog;
      const form = dialog.querySelector('#welcome-newsletter-form'), field = form.querySelector('#welcome-email');
      if (email !== null) field.value = email;
      const error = form.querySelector('[data-newsletter-error]'), serverError = form.querySelector('[data-newsletter-server-error]');
      if (serverErrorCleared && serverError) {serverError.hidden = true; field.setAttribute('aria-invalid', 'false'); field.removeAttribute('aria-describedby');}
      if (errorText) {error.textContent = errorText; error.hidden = false; field.setAttribute('aria-invalid', 'true'); field.setAttribute('aria-describedby', error.id);}
      submission(form);
      listen(field, 'input', () => {email = field.value; errorText = ''; serverErrorCleared = true; if (serverError) serverError.hidden = true; error.textContent = ''; error.hidden = true; field.setAttribute('aria-invalid', 'false'); field.removeAttribute('aria-describedby');});
      listen(form, 'submit', () => {email = field.value; serverErrorCleared = true; queueMicrotask(() => {errorText = error.textContent;});});
      dialog.querySelector('[data-slot="dialog-title"]')?.focus({preventScroll: true});
    });
    listen(document, 'dirt:dialog-close', event => {if (event.detail.name === 'welcome') {dialog = null; controller.close(!leaving); if (!leaving && controller.state().teaser && !busy) trigger.focus({preventScroll: true});}});
    listen(window, 'scroll', refresh, {passive: true});
    const observer = new MutationObserver(refresh);
    observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded', 'data-open', 'data-closed', 'hidden', 'data-mixing']});
    const timer = setInterval(() => {
      if (leaving) return;
      controller.tick({visible: document.visibilityState === 'visible', blocked: blocked(), typing: !!document.activeElement?.closest('input, textarea, select, [contenteditable="true"], form')});
    }, 1000);
    roots.set(root, {controller, dispose() {controller.dispose(); abort.abort(); observer.disconnect(); clearInterval(timer); if (dialog) paper.closeDialog?.(); roots.delete(root);}});
    refresh(); if (preview) controller.show();
  }
  function init(scope = document) {for (const root of scope.querySelectorAll('[data-welcome-root]')) mount(root); if (scope.matches?.('[data-welcome-root]')) mount(scope);}
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('#welcome-newsletter-form') && !form.closest?.('[data-paper-newsletter-footer]')) return;
    submission(form)?.submit(event, form.querySelector('[name="contact[email]"]'));
  }, true);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {for (const [root, state] of roots) if (event.target.contains(root)) state.dispose();});
  window.addEventListener('pagehide', () => {leaving = true;}, true);
  window.addEventListener('pageshow', () => {leaving = false; for (const form of document.querySelectorAll('#welcome-newsletter-form, [data-paper-newsletter-footer] form')) forms.get(form)?.reset(); init();});
  paper.newsletter = {init}; init();
})();
